'use client';

import { BookOpen, CreditCard, Mail, Sparkles } from 'lucide-react';

const STEPS = [
  {
    step: 1,
    title: 'Выберите мастер-класс',
    desc: 'Описание, материалы и примеры работ — всё на странице МК',
    icon: BookOpen,
  },
  {
    step: 2,
    title: 'Оформите заказ',
    desc: 'Оплата картой, СБП и другими способами',
    icon: CreditCard,
  },
  {
    step: 3,
    title: 'Получите материалы',
    desc: 'Файлы и чек придут на указанную почту',
    icon: Mail,
  },
  {
    step: 4,
    title: 'Вяжите с удовольствием',
    desc: 'Пошаговые схемы и понятные объяснения',
    icon: Sparkles,
  },
] as const;

export const HomeHowItWorks = () => {
  return (
    <section
      className="w-full py-10 md:py-14"
      aria-labelledby="home-how-it-works-heading"
    >
      <h2
        id="home-how-it-works-heading"
        className="text-center text-2xl font-bold text-foreground md:text-3xl mb-8 md:mb-10"
      >
        Как купить мастер-класс
      </h2>
      <div className="-mx-4 px-4 md:mx-0 md:px-0">
        <div
          className="flex flex-nowrap gap-4 overflow-x-auto pb-2 pt-1 [-webkit-overflow-scrolling:touch] scroll-smooth overscroll-x-contain snap-x snap-mandatory no-scrollbar"
          role="list"
          aria-label="Шаги: как купить мастер-класс"
        >
        {STEPS.map((item) => (
          <div
            key={item.step}
            role="listitem"
            className="relative flex min-w-[240px] max-w-[280px] shrink-0 snap-start flex-col rounded-2xl border border-default-200 bg-content1/40 p-5 text-center shadow-sm backdrop-blur-sm sm:min-w-[260px] md:p-6 dark:bg-default-100/10"
          >
            <span className="mx-auto inline-flex h-11 w-11 items-center justify-center rounded-full bg-warning/15 text-warning">
              <item.icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <span className="mt-3 text-xs font-semibold uppercase tracking-wide text-default-500">
              Шаг {item.step}
            </span>
            <h3 className="mt-1 font-semibold text-foreground">{item.title}</h3>
            <p className="mt-2 text-sm text-default-600">{item.desc}</p>
          </div>
        ))}
          <div className="shrink-0 w-3 md:w-4" aria-hidden />
        </div>
      </div>
    </section>
  );
};
